import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { SponsoredHeader } from 'site-modules/cpo/components/sponsored-header/sponsored-header';
import { CpoModel } from 'client/data/models/cpo';
import { SearchByModule } from 'site-modules/shared/components/search-by-module/search-by-module';
import { MMZ_CPO_TRACKING_IDS } from 'client/tracking/maps/cpo/cpo';
import { TAB_IDS } from 'site-modules/shared/constants/search-by-module';

export function ShopCpoInventoryUI({ content, isMobile, location }) {
  return (
    <>
      <SponsoredHeader
        titleClassName="mb-1_5 text-white heading-4 font-weight-normal text-shadow"
        url={content.url}
        image={content.image}
        title="Research and find certified cars for sale"
      />
      <SearchByModule
        className="shop-cpo bg-white rounded-16 overflow-hidden"
        location={location}
        isMobile={isMobile}
        isCpo
        trackingMap={MMZ_CPO_TRACKING_IDS}
        showTabs={[TAB_IDS.MAKE_MODEL_TAB, TAB_IDS.PRICE_TAB]}
      />
    </>
  );
}

ShopCpoInventoryUI.propTypes = {
  content: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  location: PropTypes.shape({}),
};

ShopCpoInventoryUI.defaultProps = {
  content: {
    url: '',
    image: '',
  },
  isMobile: false,
  location: {},
};

export const stateToPropsConfig = {
  content: bindToPath('inventoryLogo', CpoModel),
};

export const ShopCpoInventory = connectToModel(ShopCpoInventoryUI, stateToPropsConfig);
